import React from 'react';

interface Props {
    price: number;
    // isWithDollarSign?: boolean;
    clasName?: string;
    isInCents?: boolean;
}

const Price = ({ price, clasName = '', isInCents = true }: Props) => {
    return (
        <span className={clasName}>
            {new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
            }).format(isInCents ? price / 100 : price)}
        </span>
    );
};

export default Price;
